module.exports = __webpack_public_path__ + "img/toeic4.2156d318.png";